"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BottomBar = _interopRequireDefault(require("./BottomBar.scss"));

var _Constants = require("../../constants/Constants");

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _ObjectHelper = require("../../../helpers/ObjectHelper");

var _ColorHelper = require("../../../helpers/ColorHelper");

var _Image = _interopRequireDefault(require("../Image/Image"));

var _strings = require("../../../../config/strings");

var _CordovaFileHelper = _interopRequireDefault(require("../../../helpers/CordovaFileHelper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var BottomBar = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(BottomBar, _DataStoreComponent);

  var _super = _createSuper(BottomBar);

  function BottomBar(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, BottomBar);
    _this = _super.call(this, props);
    _this.state = {
      navbar: null,
      currentTheme: null,
      filePath: _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder()
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(BottomBar.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE, _DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(BottomBar.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['navbar', 'currentTheme']
    }]);
    return _this;
  } // TODO: tidy up, make target independent


  (0, _createClass2["default"])(BottomBar, [{
    key: "getStyles",
    value: function getStyles() {
      var theme = null;

      if (this.state.navbar && this.state.currentTheme in this.state.navbar) {
        theme = this.state.navbar[this.state.currentTheme];
      }

      var defaultTheme = this.state.navbar ? this.state.navbar["default"] : null;
      var style = {
        color: (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarText', defaultTheme, 'navbarText', _ColorHelper.COLOR.BLACK),
        backgroundColor: _ColorHelper.COLOR.WHITE,
        bottom: 0,
        position: 'absolute',
        overflow: 'hidden',
        zIndex: _Constants.GLOBAL_Z_INDEXES.navbar,
        transition: 'opacity 300ms 300ms',
        opacity: 1
      };

      if (this.props.hidden) {
        style.opacity = 0;
        style.zIndex = -1;
      }

      return {
        bottomBar: style
      };
    }
  }, {
    key: "renderForElement",
    value: function renderForElement(element, index, totalCount) {
      var _this2 = this;

      if (!element.condition()) {
        return null;
      }

      var imgSrc = element.svgIcon || element.icon; // if (!DeviceInfoHelper.isBrowser()) {
      //   imgSrc = `${this.state.filePath}${imgSrc}`
      // }

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "bb_elem_".concat(index),
        className: _BottomBar["default"].container,
        style: {
          width: "".concat(totalCount > 0 ? 100 / totalCount : 20, "%")
        },
        onClick: /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return element.callback();

                case 2:
                  _this2.forceUpdate();

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: imgSrc,
        alt: 'Inaktives Menüicon',
        className: _BottomBar["default"].iconUnactive
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: _BottomBar["default"].title,
        style: {
          color: '#9b9b9b'
        }
      }, (0, _strings.getString)(element.labelKey)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var dynamicStyles = this.getStyles();
      var totalCount = this.props.elements.map(function (element) {
        return element.condition ? element.condition() : true;
      }).filter(Boolean).length;
      var icons = this.props.elements.map(function (element, index) {
        return _this3.renderForElement(element, index, totalCount);
      }).filter(Boolean);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _BottomBar["default"].bottomBar,
        style: dynamicStyles.bottomBar
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '100%'
        }
      }, icons));
    }
  }]);
  return BottomBar;
}(_DataStoreComponent2["default"]);

BottomBar.propTypes = {
  elements: _propTypes["default"].array.isRequired,
  hidden: _propTypes["default"].bool
};
BottomBar.defaultProps = {
  hidden: false
};
var _default = BottomBar;
exports["default"] = _default;